import { useMonarchRule } from '../../MonarchRulesProvider';
import {
  TestimonialContent,
  UseValueReinforcementTestHookResult,
  ValueReinforcementResult,
  ValueReinforcementVariant,
} from './types';

const CUSTOM_RULE_ID = 'checkoutValueReinforcementTest';

export type ValueReinforcementRequestData = {
  valueReinforcementEnabled: boolean;
  careerCardEnabled: boolean;
  testimonialCardEnabled: boolean;
  statsBarEnabled: boolean;
  encouragementBannerEnabled: boolean;
  testimonialContent: TestimonialContent;
};

const useValueReinforcement: UseValueReinforcementTestHookResult = () => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    data: ValueReinforcementRequestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value?.data) {
    return {
      isLoading,
    } as ValueReinforcementResult;
  }

  // Determine the variant based on the returned data
  const variant: ValueReinforcementVariant = value.data
    .valueReinforcementEnabled
    ? 'test'
    : 'control';
  // Return the experiment result with proper typing
  return {
    isLoading: false,
    variant,
    data: {
      isValueReinforcementEnabled: value.data.valueReinforcementEnabled,
      isCareerCardEnabled: value.data.careerCardEnabled,
      isTestimonialCardEnabled: value.data.testimonialCardEnabled,
      isStatsBarEnabled: value.data.statsBarEnabled,
      isEncouragementBannerEnabled: value.data.encouragementBannerEnabled,
      testimonialContent: value.data.testimonialContent,
    },
  };
};

export default useValueReinforcement;
